var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './tag.styles';
import '../icon-button/icon-button.js';
import { SgdfElement } from '../../internal/sgdf-element';
/**
 * @since 0.1
 * @status stable
 *
 * @dependency sgdf-icon-button
 *
 * @slot - The tag's content.
 *
 * @event sgdf-delete - Emitted when the remove button is activated.
 *
 * @csspart base - The component's base wrapper.
 * @csspart content - The tag content.
 * @csspart remove-button - The remove button.
 */
let SgdfTag = class SgdfTag extends SgdfElement {
    constructor() {
        super(...arguments);
        this.primary = false;
        this.success = false;
        this.neutral = false;
        this.warning = false;
        this.danger = false;
        /** Draws an outlined button. */
        this.outlined = false;
        /** The tag's size. */
        this.size = 'medium';
        /** Draws a pill-style tag with rounded edges. */
        this.pill = false;
        /** Makes the tag removable. */
        this.removable = false;
    }
    handleRemoveClick() {
        this.emit('sgdf-delete');
    }
    render() {
        const modes = {
            primary: this.primary &&
                !this.success &&
                !this.neutral &&
                !this.warning &&
                !this.danger,
            success: !this.primary &&
                this.success &&
                !this.neutral &&
                !this.warning &&
                !this.danger,
            neutral: !this.primary &&
                !this.success &&
                this.neutral &&
                !this.warning &&
                !this.danger,
            warning: !this.primary &&
                !this.success &&
                !this.neutral &&
                this.warning &&
                !this.danger,
            danger: !this.primary &&
                !this.success &&
                !this.neutral &&
                !this.warning &&
                this.danger,
            tag: true,
            // Sizes
            'tag--small': this.size === 'small',
            'tag--medium': this.size === 'medium',
            'tag--large': this.size === 'large',
            // Modifers
            'tag--pill': this.pill,
            'tag--removable': this.removable,
        };
        // simple mode is default when no value or when there are multiple conflicting values
        modes.simple =
            !this.primary &&
                !modes.success &&
                !this.neutral &&
                !modes.warning &&
                !modes.danger;
        // outlined is not default except in simple mode
        modes.outlined = this.outlined || modes.simple;
        return html `
            <span part="base" class=${classMap(modes)}>
                <span part="content" class="tag__content">
                    <slot></slot>
                </span>
                ${this.removable
            ? html `
                          <sgdf-icon-button
                              exportparts="base:remove-button"
                              name="x"
                              class="tag__remove"
                              @click=${this.handleRemoveClick}
                          ></sgdf-icon-button>
                      `
            : ''}
            </span>
        `;
    }
};
SgdfTag.styles = styles;
__decorate([
    property({ type: Boolean })
], SgdfTag.prototype, "primary", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTag.prototype, "success", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTag.prototype, "neutral", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTag.prototype, "warning", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTag.prototype, "danger", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTag.prototype, "outlined", void 0);
__decorate([
    property({ reflect: true })
], SgdfTag.prototype, "size", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfTag.prototype, "pill", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTag.prototype, "removable", void 0);
SgdfTag = __decorate([
    customElement('sgdf-tag')
], SgdfTag);
export default SgdfTag;
//# sourceMappingURL=tag.js.map